export default __webpack_public_path__ + "3498450e6ebfb4300f15cdb32b89a770.png";